"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ActionGroupMulti = void 0;
require("./ActionGroupMulti.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _getButtonHtmlMulti = require("../../util/getButtonHtmlMulti/getButtonHtmlMulti");
var _getLinkHtmlMulti = require("../../util/getLinkHtmlMulti/getLinkHtmlMulti");
var _renderObject = require("../../util/renderObject/renderObject");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ActionGroupMulti component
 *
 * @method
 * @param { ActionGroupMultiProps } props
 * @returns ActionGroupMulti
 */

const ActionGroupMulti = props => {
  const {
    actions,
    actionStyle,
    // DXL Only
    alignment = defaultProps.alignment,
    // Set in card, hero, etc
    externalActions,
    hasOneExternalAction,
    isKnockoutLink,
    // Set in card, hero, etc
    style,
    types = defaultProps.types
  } = props;
  if (!actions && !externalActions) {
    return null;
  }

  /* Checks if there are multiple actions */
  const hasOneAction = actions?.length === 1 || hasOneExternalAction;

  /* Set the array of actions to be mapped over */
  let actionGroups = [];

  /* Set the default link styles */
  let linkStyle = {
    variant: 'primary',
    size: 'compact'
  };

  /* Set the default button styles */
  let buttonStyle = {
    variant: 'secondary',
    size: 'tiny'
  };
  if (!externalActions) {
    actionGroups = actions.map((action, index) => (0, _actionFormatter.actionFormatter)({
      linkStyle,
      buttonStyle,
      action: action,
      index: index,
      types: types,
      style: style,
      actionStyle: actionStyle,
      isKnockoutLink: isKnockoutLink,
      hasOneAction: hasOneAction
    }, {
      getButtonMarkup: _getButtonHtmlMulti.getButtonHtmlMulti,
      getLinkMarkup: _getLinkHtmlMulti.getLinkHtmlMulti
    }));
  }
  if (externalActions) {
    actionGroups = externalActions;
  }
  const componentClassName = (0, _classnames.default)('pal-c-ActionGroupMulti', {
    [`pal-c-ActionGroupMulti--${types}`]: types,
    [`pal-c-ActionGroupMulti--${alignment}`]: alignment
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasOneAction && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(actionGroups)), !hasOneAction && /*#__PURE__*/_react.default.createElement("ul", {
    className: "pal-c-ActionGroupMulti--list"
  }, (0, _renderObject.renderObject)(actionGroups))));
};

/**
 * Property type definitions
 * @typedef ActionGroupMultiProps
 * @type {object}
 * @property {array} actions - Array of actions
 * @property {string} alignment - String to align the actions
 * @property {object} actionStyle - DXL ONLY style for the button or link
 * @property {array} externalActions - Array of actions
 * @property {string} types - sets the style to button or link
 */
exports.ActionGroupMulti = ActionGroupMulti;
const propTypes = exports.propTypes = {
  /**
   * Array of actions (palette only, no business logic)
   */
  actions: _propTypes.default.array,
  /**
   * Object of the button or link styles (palette only, no business logic)
   */
  actionStyle: _propTypes.default.object,
  /**
   * Boolean to center the actions
   */
  alignment: _propTypes.default.oneOf(['left', 'center', 'right']),
  /**
   * Array of action from an external source that contains business logic
   */
  externalActions: _propTypes.default.array,
  /**
   * Sets the stylistic version of the actions
   * - **button:** Sets the actions to display as a button
   * - **link:** Sets the actions to display as a link
   */
  types: _propTypes.default.oneOf(['button', 'link'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} alignment='left' - sets the boolean to center the actions
 * @property {string} types='button' - sets the default types to button
 */
const defaultProps = exports.defaultProps = {
  alignment: 'left',
  types: 'button'
};
ActionGroupMulti.propTypes = propTypes;
var _default = exports.default = ActionGroupMulti;